import {
  ASSIGNMENT_DURATION_OPTIONS,
  CONTEST_DURATION_OPTIONS,
  HOMEWORK_DURATION_OPTIONS,
  LIVE_LECTURE_DURATION_OPTIONS,
  PRE_READ_DURATION_OPTIONS,
} from './lessonDurationOptions';
import { LESSON_TYPES } from './lessonTypes';

export const LESSON_INPUT_OPTIONS = {
  [LESSON_TYPES.liveLecture]: {
    duration: LIVE_LECTURE_DURATION_OPTIONS,
    label: 'Live Lecture',
  },
  [LESSON_TYPES.assignment]: {
    duration: ASSIGNMENT_DURATION_OPTIONS,
    label: 'Assignment',
  },
  [LESSON_TYPES.homework]: {
    duration: HOMEWORK_DURATION_OPTIONS,
    label: 'Homework',
  },
  [LESSON_TYPES.preRead]: {
    duration: PRE_READ_DURATION_OPTIONS,
    label: 'Pre Read',
  },
  [LESSON_TYPES.contest]: {
    duration: CONTEST_DURATION_OPTIONS,
    label: 'Contest',
  },
};
